import { FaRegFile } from "react-icons/fa";
import "./styles.css";

/* eslint-disable react/prop-types */
export function UploadButton({ label, onFileChange, file, isDisabled }) {
  const handleChange = (e) => {
    if (e.target.files.length > 0) {
      onFileChange(e.target.files[0]);
    }
  };

  const isBlobOrFile = (f) => f instanceof Blob || f instanceof File;

  return (
    <label className={`uploadButton ${isDisabled ? 'disabled' : ''}`.trim()}>
      {file ? (
        <>
          <img
            src={isBlobOrFile(file) ? URL.createObjectURL(file) : file}
            alt="preview"
            className="previewImage"
          />
          {!isDisabled && <div className="overlay">Trocar</div>}
        </>
      ) : (
        <>
          <span className="uploadIcon">
            <FaRegFile />
          </span>
          <span>{label}</span>
        </>
      )}
      <input type="file" accept="image/*" onChange={handleChange} hidden disabled={isDisabled} />
    </label>
  );
}
